import { UploadedPolicyAdapter } from '../../../adapter';

export default async function UploadedPolicyGetUseCase(event) {
    console.log('UploadedPolicyGetUseCase received usecase: ', event);

    const { loanAccountNumber, mobileNo, email, page } = event;

    const url = window.location.href;
    const isLocalhost = url.includes('localhost') || url.includes('hcc.dev.bpimsapps.com');
    const isUAT = url.includes('hcc.uat.bpimsapps.com');
    const isProd = url.includes('homeprotectionclaims.bpims.com');
    const [, stage, , flag] = url.split('.');

    // prepare data
    const endpoint = isLocalhost
        ? 'https://partners-api.dev.bpimsapps.com/policy/uploaded-policy/get'
        : isUAT
        ? 'https://partners-api.uat.bpimsapps.com/policy/uploaded-policy/get'
        : isProd
        ? `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/policy/uploaded-policy/get`
        : `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/policy/uploaded-policy/get`;

    // const requestUrl = 'https://partners-api.dev.bpimsapps.com/policy/uploaded-policy/get';

    let payload;

    // if (Object.keys(event).length == 3 || loanAccountNumber) {
    if (Object.keys(event).length == 4 || loanAccountNumber) {
        payload = { coicNo: !!loanAccountNumber ? loanAccountNumber : undefined, page: page || 1, size: 5 };
    }

    if (Object.keys(event).length == 3 && mobileNo && email) {
        payload = { mobileNo: !!mobileNo ? mobileNo : undefined, email: !!email ? email : undefined, page: page || 1, size: 5 };
    }

    // handle request
    const result = await UploadedPolicyAdapter(endpoint, JSON.stringify(payload));

    return result;
}
